

export const SWITCH_TYPE = {
  PRIMARY: 'primary',
  PRIMARY_REVERSE: 'primary_reverse',
  SECONDARY: 'secondary',
};



